interface ICell {
  id: string;
  label: string;
  useSort: boolean;
  width?: number;
  align?: any;
}

export const headCells: ICell[] = [
  {
    id: '',
    label: '',
    useSort: false,
    align: 'center',
  },
  {
    id: 'isSimActive',
    label: 'SIM',
    useSort: true,
  },
  {
    id: 'typeId',
    label: 'Device Type',
    useSort: true,
  },
  {
    id: 'imei',
    label: 'IMEI',
    useSort: true,
  },
  {
    id: 'status',
    label: 'Status',
    useSort: true,
  },
  {
    id: 'supplier',
    label: 'Supplier',
    useSort: true,
  },
  {
    id: 'programName',
    label: 'Program',
    useSort: true,
  },
  {
    id: 'patientFullName',
    label: 'Patient',
    useSort: true,
  },
  {
    id: 'latestHistoryLogCreatedAt',
    label: 'Last Action',
    useSort: true,
    align: 'center',
  },
  {
    id: 'actions',
    label: 'Actions',
    useSort: false,
    align: 'center',
  },
];

export default {};
